import { instanceApi } from 'libs';
import { AxiosPromise, AxiosRequestConfig } from 'axios';
import * as Types from 'types';

export const getBranchs = (): AxiosPromise<Types.BranchResponse> => {
  const request: AxiosRequestConfig = {
    url: '/branch',
    method: 'GET',
  };
  return instanceApi(request);
};

export const selectBranch = (params: Types.BranchRequest): AxiosPromise<{}> => {
  const request: AxiosRequestConfig = {
    url: '/branch/select',
    method: 'POST',
    data: params,
  };
  return instanceApi(request);
};
